import React from 'react'

export default function Home() {
  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <h1>Bem vindo administrador!</h1>
    </div>
  )
}
